import { NgModule } from '@angular/core';

import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { Apollo } from 'apollo-angular';

import { CREDENTIAL_VALIDATOR, FTP_CONNECTION_VALIDATOR } from '@ui/legacy-lib';

import { AddonPriceService } from 'landlord/screens/account/resolvers/addon-price.service';
import { effects, reducers } from './+state';

import { guards } from './guards';
import { resolvers } from './resolvers';

import {
  CredentialValidator,
  CustomerPortalConfigurationService,
  CustomQuestionFacade,
  FtpConnectionValidator,
  InventoryService,
  ObjectContingentFacade,
  PdfTemplatesFacade,
  PortalService,
  PriosetFacade,
  SchufaAccountFacade,
  SelfDisclosureFacade
} from './services';

@NgModule({
  providers: [
    provideState('AccountState', reducers),
    provideEffects(effects),
    ...guards,
    ...resolvers,
    PriosetFacade,
    SchufaAccountFacade,
    CustomQuestionFacade,
    SelfDisclosureFacade,
    PdfTemplatesFacade,
    InventoryService,
    AddonPriceService,
    PortalService,
    ObjectContingentFacade,
    CustomerPortalConfigurationService,
    {
      provide: CREDENTIAL_VALIDATOR,
      useClass: CredentialValidator,
      deps: [Apollo]
    },
    {
      provide: FTP_CONNECTION_VALIDATOR,
      useClass: FtpConnectionValidator,
      deps: [Apollo]
    }
  ]
})
export class AccountModule {}
